
import { CommandType } from "../../../../common/services/cqs/CommandType";
import { VKAtgardDTO } from "../../models/atgard-models";
import { AtgardBaseCommand } from "./AtgardBaseCommand";

export class CreateAtgardCommand extends AtgardBaseCommand {
    readonly atgardsnamn: string;
    readonly atgardstyp: string;
    readonly foreslagetProduktionsdatumFrom: any;
    readonly foreslagetProduktionsdatumTom: any;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "CreateAtgardCommand";

    constructor(atgard: VKAtgardDTO, kontraktGuid: string) {
        super(CreateAtgardCommand.$type, CommandType.Insert);
        this.atgardGuid = atgard.guid;
        this.kontraktGuid = kontraktGuid;
        this.atgardsnamn = atgard.atgardsnamn;
        this.atgardstyp = atgard.atgardstyp;
        this.foreslagetProduktionsdatumFrom = atgard.foreslagetProduktionsdatumFrom;
        this.foreslagetProduktionsdatumTom = atgard.foreslagetProduktionsdatumTom;
    }
}
